'use client'

import '@/legacy-src/styles/style.scss'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

import ErrorComponent from '@/legacy-src/components/ErrorComponent'
import SupportWidget from '@/legacy-src/components/support/SupportWidget'
import { LOCALE } from '@/legacy-src/constants/locale.constants'
import { rebrandFontVariables } from '@/legacy-src/rebrand/fonts'

export default function GlobalError({ error }) {
  useEffect(() => {
    console.error(error)
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang={LOCALE} className={`${rebrandFontVariables}`}>
      <body>
        <ErrorComponent />
        <SupportWidget />
      </body>
    </html>
  )
}
